import { FC, lazy } from 'react';

const EmailConfirmationPageDefaultView = lazy(
  () => import('./default-view/EmailConfirmationPageDefaultView'),
);

export const EmailConfirmationPage: FC = () => <EmailConfirmationPageDefaultView />;
